import React, { useState, useEffect } from 'react';
import { useStyles as classes } from "../../styles/styles";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Typography from "@mui/material/Typography";
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from "@mui/material/useMediaQuery";
import DialogTitle from "@mui/material/DialogTitle";
import EpPlea from "./EpPlea";
import RockVy from "./RockVy";
import Alert from '@mui/material/Alert';
import AlertTitle from "@mui/material/AlertTitle";

const OptionTemplateSource = (props) => {
    const open = props.open;
    const setOpen = props.setOpen;
    const optionTemplate = props.optionTemplate;
    const setFormData = props.setFormData;
    const court = props.court;
    const balances = props.balances;
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [requestData, setRequestData] = useState(false);
    const [data, setData] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [balance, setBalance] = useState(null);
    const triggerRef = React.useRef(null);

    const handleCancel = () => {
        setFormData(null);
        setOpen(false);
    }

    const handleClose = (e, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            setOpen(false);
            triggerRef.current?.focus();
        } else setOpen(true);
    }

    const handleSubmit = () => {
        setErrorMessage(null);
        setRequestData(true);
    }

    useEffect(() => {
        if (balances && !balance) {
            const tsBalances = balances.filter(b => b.trafficSchoolType);
            if (tsBalances && tsBalances.length > 0) setBalance(tsBalances[0]);
        }
    }, [balances, balance])

    useEffect(() => {
        if (errorMessage) {
            setRequestData(false);
            setData(null);
        }
    }, [errorMessage])

    useEffect(() => {
        if (data) {
            setErrorMessage(null);
            setFormData(data);
            setRequestData(false);
            setOpen(false);
        }
    }, [data])

    return (
        <>
        <Dialog
            open={open}
            maxWidth='lg'
            fullWidth
            sx={classes.dialog}
            scroll="paper"
            onClose={handleClose}
            aria-labelledby="traffic-school-dialog-title"
            aria-describedby="traffic-school-dialog-description"
        >
            { errorMessage &&
                <Alert severity='error'>
                    <AlertTitle>Error!</AlertTitle>
                    {errorMessage}
                </Alert>
            }
            <DialogTitle id="traffic-school-dialog-title">
                <Typography variant={smallScreen ? 'h6' :'h5'} component='h2' sx={{...classes.title, marginTop: '1rem'}}>
                    { optionTemplate.includes('rockVy') ? 'Rock Valley College' : court.courtName} Traffic School Form
                </Typography>
            </DialogTitle>
            <DialogContent dividers >
                <div id="traffic-school-dialog-description">
                    { optionTemplate && optionTemplate.includes('epPlea') &&
                        <EpPlea requestData={requestData} setData={setData} setErrorMessage={setErrorMessage} court={court} balance={balance} />
                    }
                    { optionTemplate && optionTemplate.includes('rockVy') &&
                        <RockVy requestData={requestData} setData={setData} setErrorMessage={setErrorMessage} court={court} balance={balance} />
                    }
                </div>
            </DialogContent>
            <DialogActions>
                <Stack direction='row' >
                    <Button
                        variant='outlined'
                        color="primary"
                        sx={classes.squashedButton}
                        onClick={handleCancel}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant='contained'
                        color="primary"
                        sx={classes.squashedButton}
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                </Stack>
            </DialogActions>
        </Dialog>
        <div style={{display: 'none'}}>
            <button ref={triggerRef}>&nbsp;</button>
        </div>
        </>
    );
}

export default OptionTemplateSource;
